export default __webpack_public_path__ + "static/media/-1.dfe8e602.png";